import React, { useEffect, useState } from 'react'
import {
    Box, Container, Stack, Tooltip, Typography, Pagination,
    Link, Button,
    Modal,
    SwipeableDrawer,
    InputLabel,
    FormControl,
    Select,
    MenuItem,
    Tabs,
    Tab,
} from '@mui/material'
import * as API from '../utils/APICalls'
import * as helpers from '../utils/helpers'
import { DataGrid } from '@mui/x-data-grid'

// import CloseButton from '../../../components/CloseButton'
export const TrackManager = ({ artist }) => {

    const [tracks, setTracks] = useState()
    const [selectedAlbum, setSelectedAlbum] = useState()
    const [currentView, setCurrentView] = useState()
    const fetchTracks = async () => {
        try {
            const tracksResp = await API.fetchTracksByArtistId(artist?._id)

            if (tracksResp?.length > 0) {
                setTracks(tracksResp)
            }
        } catch (err) {
            console.log('Error Fetching Tracks', err)
        }
    }


    const trackColumns = [
        {
            field: 'details',
            headerName: 'view',
            width: 80,
            // editable: true,
            renderCell: (params) => {
                // if (!params.row?.location?.url) {
                return (
                    <Button
                        variant="contained"
                        // color={BtnStatusColor(params.row)}
                        size="small"
                    // disabled={!params.row?.location?.url}
                    // onClick={() => handleViewEventClick(params.row)}
                    >
                        view
                    </Button>
                );
                // } 

            },
        },
        {
            field: 'name',
            headerName: 'name',
            width: 130,
            renderCell: (params) => {
                return `${params.row?.name} ${params?.row?.subtitle ? params?.row?.subtitle : ''}`
            }
        },
        {
            field: 'guest_plays', headerName: 'Guest', width: 60,
            renderCell: (params) => {
                return params.row?.guest_plays?.length
            }

        },
        {
            field: 'listeners', headerName: 'Listeners', width: 60,
            renderCell: (params) => {
                return `${params.row?.listeners?.length}`
            }

        },
        {
            field: 'shares', headerName: 'Shares', width: 60,
            renderCell: (params) => {

                return params.row?.shares?.length
            }

        },
        {
            field: 'comments', headerName: 'Comments', width: 60,
            renderCell: (params) => {

                return params.row?.comments?.length
            }

        },
        {
            field: 'albums', headerName: '+->Album', width: 100,
            renderCell: (params) => {

                return (
                    <FormControl fullWidth>
                        <InputLabel id="demo-simple-select-label">Set Length</InputLabel>
                        <Select
                            value={selectedAlbum}
                            label="length"
                            onChange={(e) => {
                                setSelectedAlbum(e.target.value)
                            }}
                        // {...register(`location.${f}`)} 
                        >
                            {artist?.albums?.map((a, i) => {
                                return (
                                    <MenuItem value={a} key={i}>{a?.title}</MenuItem>
                                )
                            })}

                        </Select>

                    </FormControl>
                )
            }

        },

        // {
        //     field: 'event_time',
        //     headerName: 'Time',
        //     width: 60,
        //     renderCell: (params) => {
        //         return helpers.convertMilitaryToAmPm(params.row?.event_time)
        //     }
        // },
        // {
        //     field: 'door_age',
        //     headerName: 'Age',
        //     width: 65,
        //     // editable: true,
        // },
        // {
        //     field: 'price',
        //     headerName: 'Price',
        //     width: 70,
        //     // editable: true,
        //     renderCell: (params) => {
        //         const adv = params.row?.price?.adv?.toLowerCase()
        //         const door = params.row?.price?.door?.toLowerCase()
        //         const priceString = adv !== door ? `$${adv ? adv + ' / ' : ''}${door ? door : ''}` : `$${adv}`
        //         let response = 'TBA'
        //         if ((adv === '0' && door === '0') || adv && door === 'free') {
        //             response = 'Free'
        //         }
        //         if (adv || door) {
        //             response = priceString
        //         }
        //         return response
        //     }

        // },

    ];

    useEffect(() => {
        const generateTracks = () => {

        }
        fetchTracks()
    }, [])
    const musicViews = ['albums', 'tracks', 'playlists']
    return (

        <Stack sx={{ justifyContent: 'center', padding: '0.5rem', overflow: 'scroll' }}>


            {tracks?.length > 0 ?
                <DataGrid
                    rows={tracks}
                    columns={trackColumns}
                    // getRowId={(row) => row?._id}
                    getRowId={(row) => tracks?.indexOf(row)}
                    initialState={{
                        pagination: {
                            paginationModel: {
                                pageSize: 15,
                                // color:'#00ff00'
                            },
                        },
                    }}
                    components={{
                        Pagination: (props) => (
                            <Pagination {...props} className="custom-pagination" />
                        ),
                    }}
                    // getRowClassName={() => 'share-row-text-color'}
                    pageSizeOptions={[10]}
                    // checkboxSelection
                    disableRowSelectionOnClick
                    sx={{
                        width: '100%',
                        padding: '0.5rem',
                        border: '1px solid #000', borderRadius: '5px',
                        boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.5)',
                        '& .MuiTablePagination-root': {
                            color: '#FF00FF', // Main text color
                        },
                        // '& .MuiTablePagination-selectLabel': {
                        //     color: '#00ff00', // "Rows per page" label color
                        // },
                        // '& .MuiTablePagination-select': {
                        //     color: '#00FF00', // Dropdown text color
                        // },
                        // '& .MuiTablePagination-displayedRows': {
                        //     color: '#FF00FF', // Displayed rows text color
                        // },
                    }}
                /> : <Stack sx={{ margin: 'auto', gap: '0.5rem', textAlign: 'center' }}>
                    <span> No Tracks Listed.</span>
                    <em style={{ fontSize: '0.75rem' }}>( You can change that by heading to booking though! )</em></Stack>}
        </Stack>

    )
}
